import { Tooltip, useTheme } from "@mui/material";
import { LockKeyhole } from "lucide-react";
import useLocales from "src/hooks/useLocales";

interface IPermissionInfoProps {
  moduleLocked?: boolean;
  style?: React.CSSProperties;
  customColor?: string;
  size?: number;
}

const PermissionInfo: React.FC<IPermissionInfoProps> = (props) => {
  const { moduleLocked, style = {}, customColor, size = "22px" } = props;
  const theme = useTheme();
  const { translate } = useLocales();
  return (
    <Tooltip
      title={translate(
        moduleLocked
          ? "this_is_an_enterprise_feature_contact_customer_support_to_enable_it"
          : "you_dont_have_permission_please_update_role_or_contact_administrator",
      )}
      placement="top"
    >
      <span>
        <LockKeyhole
          style={style}
          size={size}
          strokeWidth="1.5px"
          color={customColor || theme.palette.text.disabled}
        />
      </span>
    </Tooltip>
  );
};
export default PermissionInfo;
